import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Stack,
  Box,
  LinearProgress
} from '@mui/material';

interface MonthlyQuotaOverviewProps {
  stepsRemaining: number | null;
  monthlyQuota: number | null;
  usagePercent: number;
  getProgressColor: () => 'error' | 'warning' | 'success';
}

const MonthlyQuotaOverview: React.FC<MonthlyQuotaOverviewProps> = ({
  stepsRemaining,
  monthlyQuota,
  usagePercent,
  getProgressColor
}) => {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          Quota Overview
        </Typography>
        <Stack direction="row" spacing={4} alignItems="center" sx={{ mt: 2 }}>
          <Box>
            <Typography variant="body2" color="text.secondary">
              Credits Remaining
            </Typography>
            <Typography variant="h5">
              {stepsRemaining !== null
                ? stepsRemaining.toLocaleString('en-US')
                : 'N/A'}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              Monthly Quota
            </Typography>
            <Typography variant="h5">
              {monthlyQuota !== null
                ? monthlyQuota.toLocaleString('en-US')
                : 'N/A'}
            </Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              Usage
            </Typography>
            <LinearProgress
              variant="determinate"
              value={usagePercent}
              color={getProgressColor()}
              sx={{ height: 10, borderRadius: 5 }}
            />
            <Typography variant="caption" color="text.secondary">
              {usagePercent}%
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MonthlyQuotaOverview;
